import React, { useState, useEffect, useCallback } from "react"
import { useHistory } from "react-router-dom"
import Select from "react-select"

import { AvForm, AvField } from "availity-reactstrap-validation"

import api from "../../../services/api"

import Content from "../../../components/Content"
import ContentHeader from "../../../components/ContentHeader"
import CardHeader from "../../../components/CardHeader"
import CardFooter from "../../../components/CardFooter"
import { toast } from "react-toastify"
import Button from "../../../components/Button"

const UsuarioNovo = (props) => {
  const [loading, setLoading] = useState(false)
  const [usuario, setUsuario] = useState(null)
  const [perfilSelect, setPerfilSelect] = useState(null)
  const [optionsPerfil, setOptionsPerfil] = useState(null)

  const history = useHistory()

  const getUsuarioByPk = useCallback(() => {
    try {
      setLoading(true)
      api.get(`/user/findByPk?id=${props.match.params.id}`).then((res) => {
        const u = res.data.data
        setUsuario(u)
        api.get(`/profile/findByPk?id=${u.profile.id}`).then((res) => {
          const perfil = res.data.data
          setPerfilSelect(perfil)
        })
      })
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }, [props.match.params.id])

  function getPerfil() {
    try {
      api.get(`profile`).then((res) => {
        setOptionsPerfil(res.data.data)
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getPerfil()
    if (props.match.params.id) {
      getUsuarioByPk()
    }
  }, [getUsuarioByPk, props.match.params.id])

  const handleSubmit = function (e, errors, values) {
    if (errors.length === 0 && perfilSelect) {
      try {
        setLoading(true)
        if (!usuario.id) {
          api
            .post("/user", {
              ...usuario,
              profile_id: perfilSelect.id
            })
            .then(() => {
              toast.success(`Novo usuário incluido com sucesso.`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              })
            })
        } else {
          delete usuario['profile']
          api
            .put(`/user`, {
              ...usuario,
              profile_id: perfilSelect.id,
            })
            .then(() => {
              toast.success(`Usuário editado com sucesso.`, {
                position: "bottom-center",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: 0,
              })
            })
        }
        history.push("/user")
      } catch (err) {
        console.log(err)
      } finally {
        setLoading(false)
      }
    } else {
      if (!perfilSelect) {
        toast.error(`Campo Perfil obrigatório`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        })
      }
      errors.map((e) => {
        return toast.error(`Campo ${e} obrigatório`, {
          position: "bottom-center",
          autoClose: true,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
        })
      })
    }
  }

  return (
    <>
      <ContentHeader
        urlPrevious="/"
        previousTitle=" Pagina Inicial"
        smallTitle="Usuários"
      />
      <Content>
        <CardHeader
          title={"Usuários"}
          icon={"fa-users"}
          searchVisible={false}
        />

        <div className="box">
          <AvForm onSubmit={handleSubmit}>
            <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
              <div className="col-md-2">
                <div className="form-group">
                  <AvField
                    type="text"
                    name="Código"
                    label="Código"
                    value={usuario?.id || ""}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <AvField
                    type="text"
                    name="name"
                    label="Nome *"
                    placeholder="Nome"
                    value={usuario?.name || ""}
                    onChange={(e) =>
                      setUsuario({ ...usuario, name: e.target.value })
                    }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Digite o nome completo do usuário.",
                      },
                    }}
                    autoFocus
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="perfil">Perfil *</label>
                  <Select
                    id="selectPerfil"
                    value={perfilSelect}
                    onChange={setPerfilSelect}
                    options={optionsPerfil}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                  />
                </div>
              </div>
            </div>
            {!props.match.params.id ?
              <div className="row" style={{ padding: "10px 10px 0px 10px" }}>
                <div className="col-md-6">
                  <div className="form-group">
                    <AvField
                      type="email"
                      name="Email"
                      label="Email *"
                      placeholder="Email"
                      value={usuario?.email || ""}
                      onChange={(e) =>
                        setUsuario({ ...usuario, email: e.target.value })
                      }
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "Digite o email.",
                        },
                        email: {
                          value: true,
                          errorMessage: "Digite um email válido.",
                        },
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="senha">Senha&nbsp&nbsp</label>
                    <small>
                      <label style={{ color: "red" }}>
                        {"(gerada automáticamente)"}
                      </label>
                    </small>
                    <input
                      type="password"
                      id="inputSenha"
                      className="form-control"
                      name="senha"
                      readOnly
                    />
                  </div>
                </div>
              </div>
              : <></>}

            <div className="row" style={{ padding: "10px 10px 10px 10px" }}>
              <div className="col-md-4">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={usuario?.active || false}
                    onChange={(e) =>
                      setUsuario({ ...usuario, active: e.target.checked })
                    }
                  />
                  <label className="form-check-label">Ativo?</label>
                </div>
              </div>
            </div>

            <CardFooter loading={loading}>
              <Button type="submit" title="Salvar" loading={loading} />

              <Button
                type="button"
                title="Cancelar"
                isCanceled
                loading={loading}
                onClick={() => history.push("/user")}
              />
            </CardFooter>
          </AvForm>
        </div>
      </Content>
    </>
  )
}

export default UsuarioNovo
